import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AuthContext from '../../components/shared/AuthContext';
import { FEATURE } from '../../config/planFeatures';
import { useUserPlan } from '../../hooks/useUserPlan';

export default function TeamLeaderboardPage() {
  const { orgId } = useParams();
  const { apiClient } = useContext(AuthContext);
  const { planReady, canUseFeature } = useUserPlan();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!planReady || !canUseFeature(FEATURE.TEAM_LEADERBOARD_ANALYTICS)) return undefined;
    let cancelled = false;
    apiClient.get(`/api/organizations/${orgId}/leaderboard`).then((r) => {
      if (!cancelled) setData(r.data);
    });
    return () => {
      cancelled = true;
    };
  }, [apiClient, orgId, planReady, canUseFeature]);

  if (!data) return <p className="teams-sub">Loading leaderboard…</p>;

  return (
    <div className="teams-table-wrap">
      <table className="teams-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Member</th>
            <th>XP</th>
            <th>Level</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          {(data.entries || []).map((row) => (
            <tr key={row.userId} className={row.isCurrentUser ? 'teams-row-me' : ''}>
              <td>#{row.rank}</td>
              <td>{row.displayName}</td>
              <td>{row.xp}</td>
              <td>{row.level}</td>
              <td>{row.learningScore}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
